// frontend/src/DesignTab/PrimarySystemLegend.tsx
import React from "react";
import { Box, Group, Text, ScrollArea } from "@mantine/core";
import { useAppSelector } from "../app/hooks";
import { selectPrimarySystemLegendItems } from "../McBim/mcbimItemSelectors";

export const PrimarySystemLegend: React.FC = () => {
  const items = useAppSelector(selectPrimarySystemLegendItems);

  const visible = useAppSelector(state => state.design.showSystemColorLegend);

  if (!visible || !items?.length) {
    return null;
  }

  return (
    <Box
      w="100%"
      px="sm"
      py={6}
      style={{
        borderBottom: "1px solid rgba(0,0,0,0.08)",
        background: "rgba(255,255,255,0.75)",
        backdropFilter: "blur(4px)",
      }}
    >
      <ScrollArea h={28} type="never" scrollbarSize={0} offsetScrollbars={false}>
        <Group gap="sm" wrap="nowrap" align="center">
          {items.map((it) => (
            <Group key={it.kind} gap={6} wrap="nowrap">
              <Box
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 3,
                  background: it.color,
                  border: "1px solid rgba(0,0,0,0.18)",
                  flex: "0 0 auto",
                }}
              />
              <Text size="xs" c="dimmed" style={{ whiteSpace: "nowrap" }}>
                {it.label}
              </Text>
            </Group>
          ))}
        </Group>
      </ScrollArea>
    </Box>
  );
};
